const firebaseConfig = {
  firebase:
    process.env.NODE_ENV === "production" && process.env.REACT_APP_HOST_ENV === "production"
      ? {
        apiKey: "AIzaSyDsBOgwkPAp9voyXz7tt6ra-c8P6902Fug",
        authDomain: "suarte.firebaseapp.com",
        projectId: "suarte",
        storageBucket: "suarte.appspot.com",
        messagingSenderId: "767194707735",
        appId: "1:767194707735:web:5d5402a0dbb927e1c72952",
        measurementId: "G-62PCYC8WNF"
      }
      : {
        apiKey: "AIzaSyDPYkNQUBSmEmkeFb8C7ksqgLJbWzO_XLA",
        authDomain: "suarte-dev.firebaseapp.com",
        projectId: "suarte-dev",
        storageBucket: "suarte-dev.appspot.com",
        messagingSenderId: "429568499173",
        appId: "1:429568499173:web:c8234b57ff5221c0efe30c",
        measurementId: "G-CP5G9P3JLD"
      },
};

export default firebaseConfig;
